import { MapPin, Navigation, Clock, Phone } from "lucide-react";
import { Reveal, SectionHead } from "./Shared";

const embedFor = (loc) =>
  loc.lat && loc.lng
    ? `https://www.google.com/maps?q=${loc.lat},${loc.lng}&z=16&output=embed`
    : `https://www.google.com/maps?q=${encodeURIComponent("Electrodomésticos Rivera San Pedro Sula Honduras")}&output=embed`;

export default function Locations({ locations }) {
  if (!locations.length) return null;
  return (
    <section id="ubicaciones" data-testid="locations-section" className="bg-white py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHead
          num="06"
          testid="locations-title"
          title="Visítanos"
          sub="Dos sucursales en San Pedro Sula listas para atenderte. Te esperamos en tienda."
        />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-testid="locations-grid">
          {locations.map((loc, i) => (
            <Reveal key={loc.id || i} delay={i * 0.1} className="border border-border bg-white">
              {loc.photo && (
                <div className="aspect-[16/9] w-full overflow-hidden border-b border-border">
                  <img
                    src={loc.photo}
                    alt={`Fachada de ${loc.name} en San Pedro Sula, Cortés`}
                    loading="lazy"
                    className="h-full w-full object-cover"
                    data-testid={`location-photo-${i}`}
                  />
                </div>
              )}
              <div className="aspect-[16/10] w-full overflow-hidden border-b border-border">
                <iframe
                  title={`Mapa de ${loc.name} — San Pedro Sula`}
                  src={embedFor(loc)}
                  loading="lazy"
                  className="h-full w-full border-0"
                  referrerPolicy="no-referrer-when-downgrade"
                  data-testid={`location-map-${i}`}
                />
              </div>
              <div className="p-7 md:p-8">
                <h3 className="text-xl font-extrabold tracking-tight text-primary" data-testid={`location-name-${i}`}>
                  {loc.name}
                </h3>
                <p className="mt-2 flex items-start gap-2 text-sm text-muted-foreground">
                  <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary/50" />
                  <span>
                    {loc.address}
                    {loc.address_note && <span className="block text-xs italic">{loc.address_note}</span>}
                  </span>
                </p>
                {loc.phone && (
                  <a
                    data-testid={`location-phone-${i}`}
                    href={`tel:${loc.phone}`}
                    className="mt-3 flex items-center gap-2 text-sm font-semibold text-primary transition-colors duration-300 hover:text-whatsapp"
                  >
                    <Phone className="h-4 w-4 shrink-0" /> {loc.phone_display || loc.phone}
                  </a>
                )}
                {loc.hours && loc.hours.length > 0 && (
                  <div className="mt-5 border-t border-border pt-4" data-testid={`location-hours-${i}`}>
                    <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-muted-foreground">
                      <Clock className="h-4 w-4" /> Horario de atención
                    </p>
                    <ul className="mt-3 space-y-1.5">
                      {loc.hours.map((h, j) => (
                        <li key={j} className="flex items-center justify-between gap-4 text-sm">
                          <span className="font-semibold text-primary">{h.days}</span>
                          <span className="text-muted-foreground">{h.time}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <a
                  data-testid={`location-directions-${i}`}
                  href={loc.maps_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex h-12 items-center justify-center gap-2 bg-primary px-6 text-sm font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5"
                >
                  <Navigation className="h-4 w-4" /> Cómo llegar
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
